import React, { useState } from 'react';
import Overview from './tabs/Overview';
import StockSearch from './tabs/StockSearch';
import Settings from './tabs/Settings';
import Portfolio from './tabs/Portfolio';
import Performance from './tabs/Performance';
import Watchlist from './tabs/Watchlist';
import CongressTrades from './tabs/CongressTrades';
import '../../../css/trading.css';

const TradingHub = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview',   label: 'Overview',        icon: 'fas fa-chart-pie' },
    { id: 'portfolio',  label: 'Portfolio',        icon: 'fas fa-briefcase' },
    { id: 'watchlist',  label: 'Watchlist',        icon: 'fas fa-star' },
    { id: 'congress',   label: 'Congress',         icon: 'fas fa-landmark' },
    { id: 'search',     label: 'Stock Search',     icon: 'fas fa-search' },
    { id: 'performance',label: 'Performance',      icon: 'fas fa-chart-line' },
    { id: 'settings',   label: 'Settings',         icon: 'fas fa-cog' },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':    return <Overview />;
      case 'portfolio':   return <Portfolio />;
      case 'watchlist':   return <Watchlist />;
      case 'congress':    return <CongressTrades />;
      case 'search':      return <StockSearch />;
      case 'performance': return <Performance />;
      case 'settings':    return <Settings />;
      default:            return <Overview />;
    }
  };

  return (
    <div className="trading-container">
      <div className="trading-header">
        <h1>Trading Dashboard</h1>
      </div>

      {/* Tab Navigation */}
      <div className="tab-navigation">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <i className={`tab-icon ${tab.icon}`}></i>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default TradingHub;
